import { fillNumberWithCharacters } from '@/common/utils/string';

export const defaultDateFormatter = (newDate: Date): string => {
  return `${fillNumberWithCharacters(newDate.getMonth() + 1, 2, '0')}/${fillNumberWithCharacters(
    newDate.getDate(),
    2,
    '0',
  )}/${newDate.getFullYear()}`;
};
